exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contact-box{position:fixed;bottom:1.5rem;right:.2rem;width:1.2rem;height:1.2rem;background:linear-gradient(0deg,rgba(45,129,233,.91),rgba(135,211,255,.91));box-shadow:0 .04rem .1rem 0 #1184ed;border-radius:50%;display:flex;align-items:center;justify-content:center}.contact-box a{position:absolute;top:0;left:0;bottom:0;right:0;z-index:10;opacity:0;text-decoration:none;color:#fff;outline:none;font-size:.32rem}.contact-box a:active,.contact-box a:hover,.contact-box a:link,.contact-box a:visited{text-decoration:none;color:inherit}.contact-box .contact{position:relative;display:flex;align-items:center;justify-content:center;flex-direction:column;color:#fff;font-size:.32rem}.contact-box .contact .contact-icon{width:.4rem;height:.4rem;background:url(" + require("@/assets/images/web-mobile/home/icon-contact.png") + ") 50% no-repeat;background-size:cover}.contact-box .contact .contact-text{width:100%;height:.4rem;text-align:center;font-size:.28rem;font-weight:500;color:#fff;line-height:.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./src/assets/css/contact.css
// module id = 183
// module chunks = 28